import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { DataBlocks, Icon, CollapsedContent } from 'components';

import { PopupDisposable } from '@beef/legacy-ui-kit';
import { fetchContract } from 'actions';
import { connect } from 'react-redux';
import { Button, Text } from '@beef/ui-kit';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ServiceContract = ({
  data: {
    title,
    description,
    titleCollapsedContent,
    collapsedContent,
    linkText,
  } = {},
  downloadContract,
}) => {
  const [isDownloadContractError, setIsDownloadContractError] = useState(false);
  const showCollapsedContent = !!(titleCollapsedContent && collapsedContent);

  return (
    <DataBlocks.Block title={<span dangerouslySetInnerHTML={{ __html: title }} />} className={cx('wrap')}>
      <div className={cx('description')} dangerouslySetInnerHTML={{ __html: description }} />

      {showCollapsedContent && (
        <CollapsedContent className={cx('collapsedContent')} title={titleCollapsedContent}>
          <div dangerouslySetInnerHTML={{ __html: collapsedContent }} />
        </CollapsedContent>
      )}

      <div className={cx('container-link')}>
        <Icon name="pdf" />
        <Button
          onClick={() => downloadContract(setIsDownloadContractError)}
          variant="plain"
        >
          <Text
            className={cx('link')}
            size="size5-r-s"
            color="grey60"
          >
            {linkText}
          </Text>
        </Button>
      </div>
      {isDownloadContractError
        && (
        <PopupDisposable onClose={() => setIsDownloadContractError(false)} className={cx('popup')}>
          <h2 className={cx('popup__heading')}>
            Что-то пошло не так
          </h2>
          <div className={cx('popup__description')}>
            Ошибка загрузки договора. Попробуйте позже.
          </div>
        </PopupDisposable>
        )}
    </DataBlocks.Block>
  );
};

ServiceContract.propTypes = {
  data: PropTypes.object,
  downloadContract: PropTypes.func,
};

const mapDispatchToProps = {
  downloadContract: fetchContract,
};

export default connect(null, mapDispatchToProps)(ServiceContract);
